import React from 'react';
import { Icon } from './Icon.js';
export const IconAlertQuestion = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M12.0001 19.5L12 19.5", stroke: "currentColor", strokeWidth: "3", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M8 8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8C16 9.51419 15.1587 10.8319 13.9179 11.5111C12.949 12.0414 12 12.8954 12 14", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", strokeLinejoin: "round", fill: "none" })));
};
//# sourceMappingURL=IconAlertQuestion.js.map